import {gql} from "@apollo/client"

export const COMPANY_VALUES_QUERY = gql`
  query CompanyValues($limit: Int, $tenantId: String!) {
    companyValues(limit: $limit, tenantId: $tenantId) {
      results {
        icon {
          href
          alt
        }
        name
        uuid
        tag
      }
    }
  }
`

export const OCCASIONS_QUERY = gql`
  query Occasions($tenantId: String!) {
    occasions(tenantId: $tenantId) {
      results {
        ...Occasion
        __typename
      }
      __typename
    }
  }

  fragment Occasion on Occasion {
    uuid
    name
    desc
    tag
    default
    icon {
      href
      alt
      __typename
    }
    archived
    createdAt
    __typename
  }
`

export const USERS_FOR_BUSINESS_QUERY = gql`
  query UsersForBusiness($businessId: ID!, $adminsOnly: Boolean, $cursor: String, $enabled: Boolean, $includeBusiness: Boolean!, $lastNameCharacter: String, $totalOnly: Boolean, $offset: Int, $role: String, $searchString: String, $sort: String, $teamId: ID, $teamIds: [ID]) {
    usersForBusiness(
      businessId: $businessId
      adminsOnly: $adminsOnly
      cursor: $cursor
      enabled: $enabled
      lastNameCharacter: $lastNameCharacter
      totalOnly: $totalOnly
      offset: $offset
      role: $role
      searchString: $searchString
      sort: $sort
      teamId: $teamId
      teamIds: $teamIds
    ) {
      total
      cursor
      hasMore
      results {
        ...fullUser
        business @include(if: $includeBusiness) {
          uuid
          businessName
          __typename
        }
        __typename
      }
      __typename
    }
  }

  fragment fullUser on User {
    uuid
    dateOfBirth {
      day
      month
      year
      __typename
    }
    businessId
    email
    externalUserId
    firstName
    gender
    isEnabled
    isActivated
    lastName
    language
    metadata {
      createdAt
      createdBy
      __typename
    }
    marketingEmailsAllowed
    phoneNumber
    profileImageUrl
    source
    teamIds
    isManagedExternally
    isGlobalAdmin
    role
    primaryTeamId
    teamAssignments {
      teamId
      assignment
      __typename
    }
    __typename
  }
`

export const CREATE_RECOGNITION_MUTATION = gql`
  mutation createRecognition($recognition: RecognitionInput!) {
    createRecognition(recognition: $recognition) {
      ...Recognition
      __typename
    }
  }

  fragment Recognition on Recognition {
    uuid
    createdAt
    message
    moderated
    private
    receivers {
      results {
        ...partialUser
        __typename
      }
      __typename
    }
    teams {
      results {
        uuid
        public_name
        __typename
      }
      __typename
    }
    createdBy {
      ...partialUser
      __typename
    }
    reactions {
      results {
        reaction
        __typename
      }
      __typename
    }
    comments {
      results {
        uuid
        createdAt
        updatedAt
        createdBy {
          ...partialUser
          __typename
        }
        message
        moderated
        archived
        reactions {
          results {
            createdAt
            createdBy {
              ...partialUser
              __typename
            }
            reaction
            uuid
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    occasion {
      uuid
      name
      default
      icon {
        href
        alt
        __typename
      }
      archived
      __typename
    }
    companyValues {
      results {
        archived
        name
        tag
        uuid
        icon {
          href
          alt
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }

  fragment partialUser on User {
    uuid
    email
    firstname
    lastname
    profile_img
    firstName
    lastName
    profileImageUrl
    __typename
  }
`

export const TEAMS_QUERY = gql`
  query Teams($tenantId: String!, $state: TeamState) {
    teams(tenantId: $tenantId, state: $state) {
      limit
      count
      offset
      results {
        ...fullTeam
        __typename
      }
      __typename
    }
  }

  fragment fullTeam on Team {
    uuid
    teamName
    teamState
  }
`
